var React = require('react');

function AboutValueSimple (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#0D51FF","fillRule":"evenodd"},[React.createElement("path",{"d":"M0 42.712h17.283V60H0z","key":0}),React.createElement("ellipse",{"cx":"25.925","cy":"17.797","rx":"17.792","ry":"17.797","key":1}),React.createElement("path",{"d":"M46.783 33.56L60 60H33.567z","key":2})]));
}

AboutValueSimple.defaultProps = {"width":"60","height":"60","viewBox":"0 0 60 60"};

module.exports = AboutValueSimple;

AboutValueSimple.default = AboutValueSimple;
